import { useCart } from "@/contexts";
import { Cart, CartProduct } from "@/interfaces";
import { CartRow } from "../../molecules";
import * as S from "./styles";
import { CartHelper } from "@/helpers";
import Typography from "@mui/material/Typography";

export type CartTableProps = {
  cart?: Cart;
  defaultProductImageUrl?: string;
};

const CartTable: React.FC<CartTableProps> = ({
  cart = undefined,
  defaultProductImageUrl = undefined,
}) => {
  const {
    remove: removeProductItemfromCart,
    setQuantity: setProductItemQuantity,
    setCoopApplied: setProductItemCoopApplied,
  } = useCart();

  const onProductItemQuantityChange = (
    id?: number,
    value?: number,
    type?: "in-store" | "shipping"
  ) => {
    if (isNaN(id as number) || isNaN(value as number)) {
      return;
    }
    // Find the item in the cart
    const item = cart?.products?.find((i) => i.productId === id);
    if (!item) return;

    console.log("Updating Shipping Quanity: ", id, value, type)

    setProductItemQuantity?.(id, value, type);

    // if (type === "shipping") {
    //   if ((value ?? 0) > 0) {
    //     setProductItemQuantity?.(id, value, type);
    //   } else {
    //     // Only remove if in-store quantity is also 0
    //     if ((item.quantity - (item.shippingQuantity || 0)) <= 0) {
    //       removeProductItemfromCart?.(id);
    //     } else {
    //       setProductItemQuantity?.(id, 0, type); // just set shippingQuantity to 0
    //     }
    //   }
    // } else {
    //   // For in-store quantity changes
    //   const shippingQuantity = item.shippingQuantity || 0;
    //   const newTotalQuantity = (value ?? 0) + shippingQuantity;
      
    //   if (newTotalQuantity > 0) {
    //     // Update the total quantity while preserving shipping quantity
    //     setProductItemQuantity?.(id, newTotalQuantity);
    //   } else if (shippingQuantity > 0) {
    //     // If we still have shipping items, just set in-store to 0
    //     setProductItemQuantity?.(id, shippingQuantity);
    //   } else {
    //     // Only remove if there are no shipping items
    //     removeProductItemfromCart?.(id);
    //   }
    // }
  };

  const onProductItemCoopAppliedChange = (id?: number, value?: number) => {
    if (isNaN(id as number) || isNaN(value as number)) {
      return;
    }

    setProductItemCoopApplied?.(id, value);
  };

  // Filter out offsite products
  const filteredCart = cart ? {
    ...cart,
    products: cart.products?.filter(product => !product.offsite) || []
  } : undefined;

  return (
    <>
      {Array.isArray(filteredCart?.products) && filteredCart?.products?.length ? (
        <>
          {/* In-Store Items Section */}
          {CartHelper.getInStoreItems(filteredCart).length > 0 && (
            <>
              <S.CartTable>
                {CartHelper.getInStoreItems(filteredCart).map((item: CartProduct) => (
                  <CartRow
                    item={item}
                    itemType="in-store"
                    key={item.productId + "-in-store"}
                    defaultProductImageUrl={defaultProductImageUrl}
                    onQuantityChange={onProductItemQuantityChange}
                    onCoopAppliedChange={onProductItemCoopAppliedChange}
                  />
                ))}
              </S.CartTable>
            </>
          )}
          
          {/* Ship Items Section */}
          {CartHelper.getShippedItems(filteredCart).length > 0 && (
            <>
              <S.ProductCartHeaderContainer>
                <S.ProductCartHeaderLabel>
                  Ship Items
                </S.ProductCartHeaderLabel>
              </S.ProductCartHeaderContainer>
              <S.CartTable>
                {CartHelper.getShippedItems(filteredCart).map((item: CartProduct) => (
                  <CartRow
                    item={item}
                    key={item.productId + "-ship"}
                    defaultProductImageUrl={defaultProductImageUrl}
                    onQuantityChange={onProductItemQuantityChange}
                    onCoopAppliedChange={onProductItemCoopAppliedChange}
                    itemType="shipping"
                  />
                ))}
              </S.CartTable>
            </>
          )}
        </>
      ) : null}
    </>
  );
};

export default CartTable;
